import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const FilledCheckmark: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_checkmark"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="checkmark icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 28 28"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M4.03033 13.4697C3.73744 13.1768 3.26256 13.1768 2.96967 13.4697C2.67678 13.7626 2.67678 14.2374 2.96967 14.5303L9.96967 21.5303C10.2626 21.8232 10.7374 21.8232 11.0303 21.5303L25.0303 7.53033C25.3232 7.23744 25.3232 6.76256 25.0303 6.46967C24.7374 6.17678 24.2626 6.17678 23.9697 6.46967L10.5 19.9393L4.03033 13.4697Z" />
      </svg>
    </span>
  );
};

export { FilledCheckmark };
